import classes from "../scss/UI/backdrop.module.scss";

const Backdrop = (props) => (
    props.reveal?<div className={classes.backdrop}></div>:null
);

export default Backdrop;
